import React from 'react';
import logoDjWillBJ from '../assets/img/webp/logoDJWILLBJ.webp';
import logoEDSB from '../assets/img/webp/logoEDSB.webp';
import {Link } from 'react-router-dom';

function Partenaires() {
    return(
        <div>
          <div className="partenaires">
            <h2>Nos partenaires</h2>
            <div className='container-partenaires'>
                <div>
                <Link  to="https://djwillbj.com" target='_blank'>
                    <img
                        src={logoDjWillBJ}
                        alt="DJ WillBJ"
                        width="250"
                        height="160"
                    />
                </Link>
                </div>
                <div>
                <Link  to="https://www.edsb.fr/" target='_blank'>
                    <img
                        src={logoEDSB}
                        alt="EDSB"
                        width="250"
                        height="160"
                    />
                </Link>
                </div>
            </div>
          </div>
        </div>
      )
}

export default Partenaires;